import React from "react";

import "./WbIcon.sass";

function WbIcon({ icon }) {
  return <i className={`wb-${icon}`} />;
}

export default WbIcon;
